<template>
  <v-card 

    class="ma-3"
    :style="cardMoment"
    flat>
    <v-btn 
      id="momentSign"
      style="margin: 12px 0  0 -12px; height: 30px; width: 30px; cursor: default;"
      absolute
      fab
      depressed
      small
      dark 
      color="amber lighten-2">
      <v-icon
        icon-color="white"
        height="20"
        width="20">
        $vuetify.icons.chartbubble
      </v-icon>
    </v-btn>
    <!-- <v-layout
            row
            wrap>
            <v-flex>
              <v-flex 
                style=" flex: 0 0 auto;">
                <v-img 
                  :src="post.imgUrl"
                  aspect-ratio="1"
                  class="card-avatar">
                </v-img>
              </v-flex>
            </v-flex>
            <v-flex>
              <v-flex 
                style="overflow: hidden;"
                ml-3>
                <div class="subheading">
                  <span class="font-weight-bold">
                    {{ post.name }}
                  </span>
                  <article class="font-weight-light caption">
                    &#183; {{ postedTime }}
                  </article>
                </div>
              </v-flex>
            </v-flex>
          </v-layout> -->

    <!-- <v-card-title style="height: 65px">
            <v-layout column>
              <v-layout
                row>
                <v-flex 
                  style=" flex: 0 0 auto;">
                  <v-img 
                    :src="post.imgUrl"
                    aspect-ratio="1"
                    class="card-avatar">
                  </v-img>
                </v-flex>
          
                <v-flex 
                  style="overflow: hidden;"
                  ml-3>
                  <div class="subheading">
                    <span class="font-weight-bold">
                      {{ post.name }}
                    </span>
                    <article class="font-weight-light caption">
                      &#183; {{ postedTime }}
                    </article>
                  </div>
                </v-flex> -->

    
    <!-- </v-layout>
            </v-layout>
          </v-card-title> -->


    <v-card-text 
      :style="cardInfo"
      style="border-top-left-radius: 16px; border-top-right-radius: 16px;">
      <v-layout
        align-center
        justify-space-between
        row
        fill-height>
        <v-flex 
          style="min-width: 52px">
          <v-hover>
            <v-img 
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 10 : 8}`"
              class="card-avatar"
              style="cursor: pointer"
              :src="post.imgUrl"
              aspect-ratio="1"
              @click.native="$router.push('/profile/' + post.uniqueId)">
            </v-img>
          </v-hover>
        </v-flex>
        <v-flex xs9>
          <v-flex 
            xs12>
            <v-flex>
              <span class="title">
                {{ post.title }}
              </span>
            </v-flex>
            <v-flex
             
              class="mt-2r">
              <router-link
                :to="'/profile/' + post.uniqueId"
                tag="span"
                style="cursor: pointer">
                <v-icon
                  small>
                  fas fa-user-circle fa-fw
                </v-icon>
                <span
                  class="font-weight-light"
                  style="color: #424242">
                  {{ post.name }} 
                </span>
              </router-link>      
              <!-- <span class="ml-1 caption grey--text font-italic">
                <v-icon size="14">
                  fas fa-fingerprint
                </v-icon> {{ post.uniqueId }}
              </span> -->
            </v-flex>
            <v-flex
              v-if="!isMobile"
              class="mt-2r">
              <v-icon small>
                far fa-calendar-day fa-fw
              </v-icon>
              <!-- TODO: Text/Translate -->

              <span
                class="font-weight-light" 
                style="color: #424242">          
                {{ post.date | dateLong }} <span class="font-italic">
                  um
                </span> {{ post.date | time }} Uhr
              </span>
            </v-flex>
            <v-layout
              v-else
              row
              wrap>
              <v-flex
                xs12
                class="mt-2r">
                <v-icon small>
                  far fa-calendar-day fa-fw
                </v-icon>
                <span
                  class="font-weight-light" 
                  style="color: #424242">          
                  {{ post.date | dateLong }} 
                </span>
              </v-flex>
              <v-flex
                xs12
                class="mt-2r">
                <v-icon small>
                  far fa-clock fa-fw
                </v-icon>
                <span
                  class="font-weight-light" 
                  style="color: #424242">          
                  {{ post.date | time }} Uhr 
                </span> 
              </v-flex>
            </v-layout>


            <v-flex class="mt-1">
              <span 
                style="cursor: pointer;"
                @click="show = !show">
                <v-icon 
                  small>
                  fas fa-map-marker-alt fa-fw
                </v-icon>
                {{ post.location }}
                <v-btn
                  class="ma-0"
                  icon
                  small
                  flat
                  :color="catMainColor">
                  <v-icon 
                    small
                    style="vertical-align: middle">
                    {{ show ? 'fal fa-chevron-circle-up' : 'fal fa-chevron-circle-down' }}
                  </v-icon>
                </v-btn>
              </span>
            </v-flex>
          </v-flex>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-layout column>
            <v-flex>
              <v-btn 
                fab
                small
                :color="catMainColor" 
                style="cursor: default;" 
                :ripple="false"
                dark>
                <v-icon 
                  dark>
                  {{ catMainIcon }}
                </v-icon>
              </v-btn>
            </v-flex>
            <v-flex>
              <v-btn 
                v-if="post.secondCat"
                fab
                small
                :color="catSecondColor" 
                :ripple="false"
                style="cursor: default;" 
                dark>
                <v-icon 
                  dark>
                  {{ catSecondIcon }}
                </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>


      
      <v-layout 
        v-show="show"
        mt-2  
        row 
        fill-height>
        <v-flex 
          xs12
          class="roundedcard">
          <!-- <v-img 
            :src="require('@/assets/map.png')"
            class="roundedcard"
            height="125">
          </v-img> -->
          <div
            class="roundedcard"
            style="overflow: hidden;">
            <iframe
              width="100%"
              height="220px"
              frameborder="0"
              style="border:0;"
              :src="'https://www.google.com/maps/embed/v1/place?key=' + GOOGLE_MAPS_API + '&q=' + post.coordinates.lat + ',' + post.coordinates.lng + '&zoom=10'" />
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-text
      class="text-xs-center">
      <template v-if="!showCompleteDesc">  
        <template v-for="(line, index) in truncateDesc.split('\n')">
          {{ line }}
          <br :key="index">
        </template>
        <v-btn
          v-if="post.description.length > postLength"
          small
          round
          flat
          class="mb-0 caption font-weight-bold"
          @click="showCompleteDesc = true">
          <!-- TODO: Text/Translate -->

          Mehr anzeigen...
        </v-btn>
      </template>
      <template v-else>
        <template v-for="(line, index) in post.description.split('\n')">
          {{ line }}
          <br :key="index">
        </template>
        <v-btn
          v-if="showCompleteDesc"
          small
          round
          flat
          class="mb-0 caption font-weight-bold"
          @click="showCompleteDesc = false">
          <!-- TODO: Text/Translate -->

          Weniger anzeigen...
        </v-btn>
      </template>
    </v-card-text>
   

    <v-divider light></v-divider>

    <v-card-actions>
      <v-layout
        align-center
        justify-space-between
        row>
        <v-flex 
          ml-4
          style="flex: 0 0 auto"
          d-inline-flex>
          <v-avatar
            v-if="post.subscribersNum === 0"
            style="margin-left: -16px"
            size="28"
            tile
            class="wevent_icon_wrapper_icons"> 
            <v-img 
              class="wevent_icon"
              contain
              :src="require('@/assets/LOGO_SVG_v2.svg')">
            </v-img>
          </v-avatar>
          
          <template
            v-for="index in post.subscribersNum"
            v-else>
            <v-img 
              v-if="index <= numOfSubscribers"
              :key="index"
              :src="PROFILE_IMG"
              class="card-participants">
            </v-img>
          </template>
            
          <article 
            v-if="post.subscribersNum > numOfSubscribers"
            class="caption ml-1 my-auto" 
            style="color: grey;">
            +{{ post.subscribersNum - numOfSubscribers }}
          </article>
        </v-flex>
        
        <v-spacer></v-spacer>
      
       

        <v-flex>
          <v-btn 
            :icon="isMobile"
            :round="!isMobile"
            :small="!isMobile"
            :color="catMainColor"
            flat
            @click="debounceFavMoment(post)">
            <v-icon>
              {{ favIconHeart }}
            </v-icon>
          </v-btn>
        </v-flex>
        <!-- TODO 
        Share-Button für Moments einbauen -->
        <!-- <v-flex>
          <v-btn 
            :icon="isMobile"
            :color="catMainColor" 
            :small="!isMobile"
            :round="!isMobile"
            flat>
            <v-icon 
              dark>
              far fa-share-square
            </v-icon>
          </v-btn>
        </v-flex> -->

        <v-flex>
          <component 
            :is="isMobile ? 'MobileCardMenu' : 'DesktopCardMenu'" 
            :post="post"
            :menu-items="menuItems"
            :menu-items-user="menuItemsUser"
            :creator-id="post.creatorId"
            :user-id="user.id"
            :menucolor="catMainColor">
          </component>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { debounce, truncate } from 'lodash'

import DesktopCardMenu  from '@/components/global_comps/Cards/Desktop_CardMenu'
import MobileCardMenu   from '@/components/global_comps/Cards/Mobile_CardMenu'

export default {
  components: {
   
    // eslint-disable-next-line
    DesktopCardMenu,
    // eslint-disable-next-line
    MobileCardMenu
  },
  props: {
    post: { type: Object, default: null }    
  },
  data: () => ({
    numOfSubscribers: 3,
    showCompleteDesc: false,
    postLength: 80,
    show: false,
    GOOGLE_MAPS_API: process.env.VUE_APP_GOOGLE_MAPS_API,
    PROFILE_IMG: process.env.VUE_APP_GOOGLE_FIREBASE_PROFILE_IMG_SMALL
  }),
  computed: {
    ...mapState({
      user: state => state.user.user,

      isMobile: state => state.isMobile,
      menuItems: state => state.timeline.menuItemsMoment,
      menuItemsUser: state => state.timeline.menuItemsMomentUser,
      cats: state => state.categories
    }),
    ...mapGetters({
      // getfeaturedPosts: 'getfeaturedPosts',
      getAllFavPosts: 'getAllFavPosts',
      loading: 'loading',
      loadingEvents: 'loadingEvents',
      loadingMoments: 'loadingMoments'
    }),
    truncateDesc() {
      return truncate(this.post.description, {
        'length': this.postLength,
        'separator': /,? +/,
        'omission': ' ...'
      })
    },
    favIconHeart() {
      if (this.post.favMoment === true ) {
        return 'fas fa-heart'
      } else {
        return 'far fa-heart'
      }
    },
    catMainTitle() {
      return this.cats[this.post.mainCat].title
    },
    catMainColor() {
      return this.cats[this.post.mainCat].color
    },
    catMainRgba() {
      return this.cats[this.post.mainCat].colrgba
    },
    catMainRgbaBack() {
      return this.cats[this.post.mainCat].colrgbaback
    },
    catMainIcon() {
      return this.cats[this.post.mainCat].icon
    } ,
    cardMoment() {
      return 'background-color: rgba(255, 255, 255, 1); borderRadius: 16px; filter: drop-shadow(2px 2px 5px ' + this.catMainRgba + ');'
      // return 'background-color: rgba(255, 255, 255, 1); border: 1px solid ' + this.catMainRgba + '; borderRadius: 16px; filter: drop-shadow(2px 2px 5px ' + this.catMainRgba + ');'
    },
    cardInfo() {
      // return 'background-color: rgba(230, 27, 88, 0.05);'
      return 'background-color: ' + this.catMainRgbaBack + ';'
    },
    catSecondTitle() {
      if (this.post.secondCat) {
        return this.cats[this.post.secondCat].title
      } else {
        return null
      }
    },
    catSecondColor() {
      if (this.post.secondCat) {
        return this.cats[this.post.secondCat].color
      } else {
        return null
      }
    },
    catSecondRgba() {
      if (this.post.secondCat) {
        return this.cats[this.post.secondCat].colrgba
      } else {
        return null
      }
    },
    catSecondIcon() {
      if (this.post.secondCat) {
        return this.cats[this.post.secondCat].icon
      } else {
        return null
      }
    },

    debounceFavMoment (post) {
      return debounce(this.favMoment, 1000, {leading: true})
    }
    
  },
  methods: {
    ...mapActions([
      'addFavMoment',
      'delFavMoment'
    ]),

    favMoment(post) {
      console.log('favClick', post)
      if(post.favMoment === false) {
        this.addFavMoment(post)
      } else {
        this.delFavMoment(post)
      }
    }
  }
  
  
}
</script>



<style lang="scss" scoped>
.card-event {
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(230, 27, 88, 0.4);
  border-radius: 16px;
  filter: drop-shadow(2px 2px 5px rgba(230, 27, 88, 0.4));
}

.card-moment {
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(255, 141, 2, 0.4);
  border-radius: 16px;
  filter: drop-shadow(2px 2px 5px rgba(255, 141, 2, 0.4));
}

.card-avatar {
  border-radius: 50%;
  height: 44px;
  width: 44px;
}

.card-participants {
  border-radius: 50%;
  border: 2px solid white;
  height: 26px;
  width: 26px;
  max-height: 26px;
  max-width: 26px;
  margin-left: -14px;
}

.card-info {
  background-color: rgba(255, 141, 2, 0.05);
}

#momentSign {
  z-index: 5;
  border: 3px solid;
  background-image: linear-gradient(330deg, #d81b60, #eeff41);
}
#eventSign {
  z-index: 5;
  border: 3px solid white;
  background-image: linear-gradient(330deg, #d81b60, #eeff41);
}
 .wevent_icon {
  height: 28px !important;
  -webkit-filter: invert(1) opacity(1);
  filter: invert(1) opacity(1);

}
</style>
